import { useState } from 'react';

const API_URL = 'https://smartbid.digital';

// Colores del tier de CO₂
const TIER_COLORES = {
  verde: { fondo: '#d1fae5', texto: '#065f46', etiqueta: '🌿 Verde' },
  aceptable: { fondo: '#fef3c7', texto: '#92400e', etiqueta: '⚠️ Aceptable' },
  alto_co2: { fondo: '#fee2e2', texto: '#991b1b', etiqueta: '🔴 Alto CO₂' },
};

function App() {
  const [archivo, setArchivo] = useState(null);
  const [nombre, setNombre] = useState('');
  const [anchoPx, setAnchoPx] = useState('');
  const [altoPx, setAltoPx] = useState('');
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);

  async function subirCreativo(e) {
    e.preventDefault();
    if (!archivo || !nombre) return;

    setCargando(true);
    setError(null);
    setResultado(null);

    // FormData es la forma estándar de enviar archivos por HTTP
    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('nombre', nombre);
    if (anchoPx) formData.append('ancho_px', anchoPx);
    if (altoPx) formData.append('alto_px', altoPx);

    try {
      const respuesta = await fetch(`${API_URL}/api/creativos`, {
        method: 'POST',
        body: formData,
      });

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        setError(datos.error || 'Error al subir el creativo');
      } else {
        setResultado(datos.creativo);
      }
    } catch (err) {
      setError('No se pudo conectar con el servidor');
    } finally {
      setCargando(false);
    }
  }

  const tier = resultado ? TIER_COLORES[resultado.tier] : null;

  return (
    <div style={{ maxWidth: 600, margin: '60px auto', fontFamily: 'sans-serif', padding: '0 20px' }}>
      <h1 style={{ fontSize: 24, marginBottom: 4 }}>SmartBid</h1>
      <p style={{ color: '#6b7280', marginBottom: 32 }}>Subir creativo publicitario</p>

      <form onSubmit={subirCreativo}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>
            Nombre del creativo *
          </label>
          <input
            type="text"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            placeholder="ej. Banner Julio 2026"
            required
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 15, boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Ancho (px)</label>
            <input
              type="number"
              value={anchoPx}
              onChange={e => setAnchoPx(e.target.value)}
              placeholder="ej. 300"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 15, boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Alto (px)</label>
            <input
              type="number"
              value={altoPx}
              onChange={e => setAltoPx(e.target.value)}
              placeholder="ej. 250"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 15, boxSizing: 'border-box' }}
            />
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>
            Archivo * (JPG, PNG, GIF, WEBP — máx. 5MB)
          </label>
          <input
            type="file"
            accept="image/jpeg,image/png,image/gif,image/webp,application/zip"
            onChange={e => setArchivo(e.target.files[0])}
            required
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 15, boxSizing: 'border-box' }}
          />
          {archivo && (
            <p style={{ marginTop: 6, color: '#6b7280', fontSize: 13 }}>
              Tamaño: {(archivo.size / 1024).toFixed(1)} KB
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={cargando || !archivo || !nombre}
          style={{
            width: '100%', padding: '12px', backgroundColor: cargando ? '#9ca3af' : '#16a34a',
            color: 'white', border: 'none', borderRadius: 6, fontSize: 16,
            fontWeight: 600, cursor: cargando ? 'not-allowed' : 'pointer'
          }}
        >
          {cargando ? 'Subiendo...' : 'Subir creativo'}
        </button>
      </form>

      {error && (
        <div style={{ marginTop: 24, padding: 16, backgroundColor: '#fee2e2', borderRadius: 8, color: '#991b1b' }}>
          ❌ {error}
        </div>
      )}

      {resultado && tier && (
        <div style={{ marginTop: 24, padding: 20, backgroundColor: tier.fondo, borderRadius: 8 }}>
          <p style={{ fontWeight: 700, fontSize: 18, color: tier.texto, marginBottom: 12 }}>
            {tier.etiqueta} — Creativo registrado
          </p>
          <p style={{ color: tier.texto, margin: '4px 0' }}>📦 Tamaño: {resultado.tamano_kb} KB</p>
          <p style={{ color: tier.texto, margin: '4px 0' }}>🌱 CO₂ por impresión: {resultado.co2_por_impresion} g</p>
          <p style={{ color: tier.texto, margin: '4px 0', wordBreak: 'break-all', fontSize: 13 }}>
            🔗 URL: <a href={resultado.url_archivo} target="_blank" rel="noreferrer">{resultado.url_archivo}</a>
          </p>
        </div>
      )}
    </div>
  );
}

export default App;